export default "__VITE_ASSET__DhwwLUpa__"